import { ReactElement } from 'react'

import { MaterialIcon } from '@/components/MaterialIcon/MaterialIcon'
import {
    transformLegacyPayrollPeriodToPayrollPeriod,
} from '@/entities/PayrollPeriod/PayrollPeriodTransformers'
import { getPeriodWithoutStartOfDayCorrection } from '@/helpers/date'
import { convertDateToDateYearString } from '@/helpers/DateTimeParser'
import { PayrollPeriod } from '@/models'

import './PayrollPeriodNavigator.scss'

interface PayRollPeriodNavigatorProps {
    className?: string
    payrollPeriod: PayrollPeriod
    switchPayrollPeriod: (nextPeriod: boolean) => void
}

export function PayrollPeriodNavigator({
    className,
    payrollPeriod,
    switchPayrollPeriod,
}: PayRollPeriodNavigatorProps): ReactElement {
    const period = getPeriodWithoutStartOfDayCorrection(transformLegacyPayrollPeriodToPayrollPeriod(payrollPeriod).period)

    return (
        <div className={`payroll-navigator border-bottom ${className}`}>
            <div className="payroll-navigator__bottom">
                <button className="payroll-navigator__button" type="button" onClick={() => switchPayrollPeriod(false)}>
                    <MaterialIcon kind="chevron_left" />
                </button>
                <button
                    type="button"
                    className="mb-0 font-weight-semi-bold clear-button"
                >
                    {`${convertDateToDateYearString(period.start)} - 
                        ${convertDateToDateYearString(period.end)}`}
                </button>
                <button className="payroll-navigator__button" type="button" onClick={() => switchPayrollPeriod(true)}>
                    <MaterialIcon kind="chevron_right" />
                </button>
            </div>
        </div>
    )
}
